import { getDateFourteenDaysFromNow } from "./getDateFourteenDaysFromNow";

export const getDefaultValuesWhenNotSetExplicitly = (params) => {
  const allLoanOptions = [
    "10Fixed",
    "15Fixed",
    "20Fixed",
    "30Fixed",
    "ARM56",
    "ARM76",
    "ARM106",
  ];

  const price = params.get("purchase_price") ?? "";
  const downPayment = params.get("down_payment") ?? "";
  const creditScore = params.get("credit_score") ?? "";
  const lookingTo = params.get("looking_to") ?? "";
  const propertyType = params.get("looking_to") ?? "Single";
  const occupancyType = params.get("looking_to") ?? "Primary";
  const plannedClosingDate =
    params.get("looking_to") ?? getDateFourteenDaysFromNow();
  const hasWaivedEscrow = params.get("looking_to") ?? "No";
  const isSelfEmployed = params.get("looking_to") ?? false;
  const isUsCitizen = params.get("looking_to") ?? true;
  const isVeteran = params.get("looking_to") ?? false;
  const loanOptions = params.get("looking_to") ?? allLoanOptions;

  const firstTimeBuyerStored = localStorage.getItem("firstTimeBuyer");
  const isFirstTimeBuyer = firstTimeBuyerStored ?? "false";

  return {
    price,
    downPayment,
    creditScore,
    lookingTo,
    propertyType,
    occupancyType,
    plannedClosingDate,
    hasWaivedEscrow,
    isSelfEmployed,
    isUsCitizen,
    isVeteran,
    loanOptions,
    isFirstTimeBuyer,
  };
};
